import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { DrugCompanyService } from '../drug-company.service';
import { ToastrService } from 'ngx-toastr';
import { IDrugCompany } from '../idrug-company';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-drug-company-detail',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './drug-company-detail.component.html',
  styleUrl: './drug-company-detail.component.scss'
})
export class DrugCompanyDetailComponent {

  drugcompanyForm: FormGroup;
  isEdit: boolean;

  constructor(
    private _formbuilder: FormBuilder,
    private dialogRef: MatDialogRef<DrugCompanyDetailComponent>,
    private _drugCompanyService: DrugCompanyService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { drugcompany: IDrugCompany, isEdit: boolean, companyValue: string },
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.drugcompanyForm = this._formbuilder.group({
      name: [this._data?.drugcompany?.name, [Validators.required, Validators.maxLength(50)]],
    })
    if (this._data?.companyValue) {
      this.drugcompanyForm.patchValue({ name: this._data.companyValue })
    }
  }

  onSaveDrugCompany() {
    const data = this.drugcompanyForm.getRawValue();
    this._drugCompanyService.createDrugCompany(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('LABEL.DRUG_COMPANY')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onUpdateDrugCompany() {
    const data = {
      id: this._data?.drugcompany?.id,
      ...this.drugcompanyForm.getRawValue()
    };

    this._drugCompanyService.updateDrugCompany(data).subscribe((response) => {

      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('LABEL.DRUG_COMPANY')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }
}
